module.exports = __webpack_public_path__ + "img/undraw_questions_re_1fy7.46f9a5a5.svg";